import React from "react";

const AuthorTop = () => {
  return (
    <>
      <div className="border-t-2 border-b-2 border-gray-200 py-2">
        <div className="px-3 md:px-0 flex flex-row justify-between items-center">
          <div className="uppercase text-sm font-bold flex flex-row items-center">
            <div>
              <img
                className="w-10 h-10 mr-3 rounded-full"
                src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/about-image-300x300.jpg"
              />
            </div>
            <div className=" text-xs">amir vans</div>{" "}
          </div>
          <div className="uppercase text-xs text-gray-500">
            august 7, 2021
          </div>
          <div className="text-gray-500">
            <i class="fas fa-comment-alt px-1.5"></i>
            <sup>1008</sup>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthorTop;
